import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "./useWeb3";
import environment from "../utils/Environment";
import { insuranceContract } from "../utils/contractHelpers";

export const IsInsuranceClaimed = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = environment.insurance;
  const contract = insuranceContract(tokenAddress, web3);
  const isInsuranceClaimed = useCallback(
    async (account, index) => {
      try {
        var approved;

        approved = await contract.methods.isClaimed(account, index).call();
        return approved;
      } catch (err) {
        console.log("aganssaf", err);
      }
    },
    [account, contract]
  );

  return { isInsuranceClaimed: isInsuranceClaimed };
};

export default IsInsuranceClaimed;
